import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./SuccessHandler.sass";
import help_image from "../images/Illustration-help.png";
import { BASE, shouldUseOptIn } from "../basedata/constants";
import { useNavigate } from "react-router-dom";
import { useStep } from "../context/StepContext"

const ErrorOptin = () => {
  const { t } = useTranslation(); 
  const { setStep } = useStep();
  const navigate = useNavigate();

  useEffect(() => {
    if (!shouldUseOptIn()) {
      navigate('/signup');
      return;
    }
    setStep(6);
  }, [navigate, setStep]);


  return (
    <div className="main-container">
      <div className="left-side"></div> 
      <div className="right-side">
        <div className="success-card">
          <img className="logo" src={BASE.company.logo} alt={BASE.company.name} />
          <h1 className="bepass-title">
            {t("user_optin_error.title")}
          </h1>
          <div className="success-message-container">
            <p className="bepass-text-default">
            {t("user_optin_error.text")}
            </p>
            <p className="bepass-text-default">
            <strong>{t("signup.labels.email")}:</strong> suporte@bepass.com.br<br/>
            {/* <strong>{t("support_message.telephone_key")}:</strong> 21 3512 1212 */}
            </p>
          </div>
          <button onClick={() => window.location.href= '/opt-in'} className="continue-button"
            >
              {t("user_optin_error.call_to_action")}
            </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorOptin;
